import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
  createTheme,
} from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";

import { Auth0Provider } from "@auth0/auth0-react";

import ErrorModal from "@components/Utility/Modals/ErrorModal";
import StaleReloadModal from "@features/appVersion/StaleReloadModal";
import { initDeployVersionGuard } from "@features/appVersion/deployVersionGuard";
import AuthUserProvider from "@features/auth/AuthUserProvider";
import GlobalConfirmProvider from "@features/confirm/GlobalConfirmProvider";
import { AppRouterCoordinator } from "@features/routing/AppRouterCoordinator";
import { store } from "@redux/store";
import AdapterUTCDateFns from "@utility/AdapterUTCDateFns";
import themeFile from "@utility/theme.jsx";
import isMobile from "@utils/mobileDetect";
import { QueryClientProviderWrapper } from "@utils/reactQuery";

import * as serviceWorker from "./serviceWorker";
import "./styles/main.css";

// Register chunk-load failure listeners and start version polling before any
// dynamic imports can fail.
initDeployVersionGuard();

if (isMobile) {
  // Disable zoom on mobile devices
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover"
    );
}

const rootEl = document.getElementById("root");

const theme = createTheme(themeFile);

const auth0ProviderConfig = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirectUri: window.location.origin,
  },
};

const root = ReactDOM.createRoot(rootEl);

root.render(
  <Provider store={store}>
    <Auth0Provider {...auth0ProviderConfig}>
      <QueryClientProviderWrapper>
        <LocalizationProvider dateAdapter={AdapterUTCDateFns}>
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={theme}>
              <AuthUserProvider>
                <GlobalConfirmProvider>
                  <AppRouterCoordinator />
                </GlobalConfirmProvider>
              </AuthUserProvider>
              <ErrorModal />
              <StaleReloadModal />
            </MuiThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>

        {/* <ReactQueryDevtools /> */}
      </QueryClientProviderWrapper>
    </Auth0Provider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
